<template>
  <button
      class="bkps-dropdown"
      v-click-outside="close"
      :disabled="!enable"
      :class="{'same-size': sameSize, 'bkps-dropdown-disabled': !enable}"
      @click="toggle"
  >
    <span class="bkps-dropdown-title" >
      <span :class="classTitle" style="margin-top: 3px;" :title="titleDropdown">{{ titleDropdown }}</span>
      <chevron-down-icon class="fa-angle-right ml-2" :class="{...getColorArrow, 'rotate-90': visible }"/>
    </span>

    <span ref="content" class="bkps-dropdown-content" :style="setPosition" :class="{ hide: !visible, active: visible }">
      <slot/>
    </span>

  </button>
</template>

<script>
  import { ChevronDownIcon } from 'vue-feather-icons'
  import ClickOutside from 'vue-click-outside'

  export default {
    components: { ChevronDownIcon },
    computed: {
      getColorArrow() {
        let obj = {}
        obj[`fa-angle-right-${this.colorArrow}`] = true
        return obj
      },
      setPosition() {
        if (this.floating)
          return this.fixedStyle

        return this.position === 'left' ? 'left: 0' : 'right: 0'
      }
    },
    data() {
      return {
        visible: false,
        fixedStyle: {}
      }
    },
    directives: { ClickOutside },
    methods: {
      close() {
        this.visible = false
        if (this.floating)
          this.unbindFloatingListeners()
      },
      toggle() {
        if (!this.enable)
          return

        this.visible = !this.visible

        if (this.floating) {
          if (this.visible) {
            this.$nextTick(this.updatePosition)
            this.bindFloatingListeners()
          } else {
            this.unbindFloatingListeners()
          }
        }
      },
      updatePosition() {
        const rect = this.$el.getBoundingClientRect()
        const content = this.$refs.content
        const menuHeight = content ? content.scrollHeight : 0

        let top = rect.bottom
        if (top + menuHeight > window.innerHeight)
          top = Math.max(10, rect.top - menuHeight)

        const style = {
          position: 'fixed',
          top: `${top}px`,
          zIndex: 1000
        }

        if (this.position === 'left')
          style.left = `${rect.left}px`
        else
          style.right = `${window.innerWidth - rect.right}px`

        this.fixedStyle = style
      },
      bindFloatingListeners() {
        window.addEventListener('scroll', this.updatePosition, true)
        window.addEventListener('resize', this.updatePosition)
      },
      unbindFloatingListeners() {
        window.removeEventListener('scroll', this.updatePosition, true)
        window.removeEventListener('resize', this.updatePosition)
      }
    },
    mounted() {
      this.popupItem = this.$el
    },
    beforeDestroy() {
      if (this.floating)
        this.unbindFloatingListeners()
    },
    name: 'Dropdown3',
    props: {
      classTitle: { type: String },
      colorArrow: { default: 'white', type: String},
      enable: { default: true, type: Boolean },
      sameSize: { default: false, type: Boolean },
      floating: { default: false, type: Boolean },
      titleDropdown: { required: true, type: String },
      position: {
        default: 'left',
        type: String,
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "./src/assets/utilities/variables";

  .bkps-dropdown {
    position: relative;
    height: 40px;
    border-radius: 5px;

    &:focus {
      outline: 0;
    }

    .bkps-dropdown-title {
      font-size: 12px;
      font-weight: bold;
      line-height: 20px;
      text-align: center;
      cursor: pointer;

      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      .fa-angle-right {
        float: right;
        transition: transform .2s;
        color: var(--dropdown-text-color);
      }

      .fa-angle-right-white {
        color: white;
      }

    }

    .bkps-dropdown-content {
      padding: 0 8px;
      top: 40px;
      transition: max-height .3s;
      border-radius: 5px;
      max-height: 0;
      font-size: 12px;
      overflow: hidden;
      position: absolute;
      background-color: var(--white-bg, #ffffff);
      color: var(--primary-text-color, #051b30);
      z-index: 10;
      box-shadow: 0px 4px 16px rgba(84, 84, 84, 0.25);
      white-space: nowrap;
      text-align: start;
    }

    .rotate-90 {
      transform: rotate(180deg);
    }

    .hide {
      max-height: 0 !important;
      padding: 0 !important;
      border: none !important;
      box-shadow: none !important;
      margin: 0 !important;
    }

    .active {
      max-height: 100vh;
    }

    ul {
      list-style-type: none;
      padding: 0;
    }

    li > ul {
      margin-left: 0px;
      margin-top: 10px;
      margin-bottom: 10px;
      border-left: 1px solid #E1E3EB;
    }

    li.bkps-dropdown-item {
      cursor: pointer;
      border-radius: 5px;
      color: var(--primary-text-color, #051b30);
      &:hover {
        background-color: var(--btn-hover-bg, #f1f1f1);
      }
    }

    li.dropdown-item {
      cursor: pointer;
      border-radius: 5px;
      color: var(--primary-text-color, #051b30);
      &:hover {
        background-color: var(--btn-hover-bg, #f1f1f1);
      }
    }

    a.dropdown-item {
      cursor: pointer;
      border-radius: 5px;
      color: var(--primary-text-color, #051b30) !important;
      text-decoration: none;
      &:hover {
        background-color: var(--btn-hover-bg, #f1f1f1);
      }
    }

  }

  .bkps-dropdown-disabled {
    background: #15CE9A50;
    color: white;
    border-style: none;
    cursor: not-allowed;

    .bkps-dropdown-title {
      cursor: not-allowed;
    }
  }

  .same-size {
    position: relative;
    .bkps-dropdown-content {
      width: 100%;
    }
  }
</style>
